var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAfIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0001 10.3755C44.0001 18.2657 34.6156 23.8482 34.6156 23.8482C34.6156 23.8482 25.2312 18.3122 25.2312 10.3755C25.2312 5.19751 29.4327 1 34.6156 1C39.7986 1 44.0001 5.19751 44.0001 10.3755Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6155 14.7486C37.033 14.7486 38.9928 12.7907 38.9928 10.3755C38.9928 7.96034 37.033 6.00244 34.6155 6.00244C32.198 6.00244 30.2383 7.96034 30.2383 10.3755C30.2383 12.7907 32.198 14.7486 34.6155 14.7486Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6156 28.1655C35.8089 28.1655 36.7763 27.199 36.7763 26.0069C36.7763 24.8147 35.8089 23.8483 34.6156 23.8483C33.4222 23.8483 32.4548 24.8147 32.4548 26.0069C32.4548 27.199 33.4222 28.1655 34.6156 28.1655Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7086 24.0083C22.7086 33.1344 11.8544 39.5912 11.8544 39.5912C11.8544 39.5912 1 33.1881 1 24.0083C1 18.0194 5.85961 13.1644 11.8544 13.1644C17.8491 13.1644 22.7086 18.0194 22.7086 24.0083Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8543 30.2893C15.3265 30.2893 18.1412 27.4773 18.1412 24.0084C18.1412 20.5396 15.3265 17.7275 11.8543 17.7275C8.38213 17.7275 5.56738 20.5396 5.56738 24.0084C5.56738 27.4773 8.38213 30.2893 11.8543 30.2893Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8543 44.5846C13.2346 44.5846 14.3535 43.4668 14.3535 42.0879C14.3535 40.709 13.2346 39.5912 11.8543 39.5912C10.4741 39.5912 9.35522 40.709 9.35522 42.0879C9.35522 43.4668 10.4741 44.5846 11.8543 44.5846Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6157 31.8938C34.6157 33.0763 33.6561 34.035 32.4724 34.035H29.259C28.0884 34.035 27.1392 34.9832 27.1392 36.1528C27.1392 37.3224 28.0883 38.2705 29.259 38.2705H38.9551C40.2214 38.2705 41.2478 39.296 41.2478 40.561C41.2478 41.8261 40.2214 42.8515 38.9551 42.8515H18.1699",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfIcon1);
export default __webpack_public_path__ + "static/media/af-icon1.332b29f0bcf37458ab231b6996049fad.svg";
export { ForwardRef as ReactComponent };